var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "21px",
    viewBox: "0 0 81 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hands") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-15",
    transform: "translate(-48.000000, -201.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.604158,201 C127.762773,201.634926 128.22576,203.366808 128.993119,206.195645 C129.034107,208.361938 128.953898,212.136775 126.970408,216.400976 C126.481997,217.450985 125.314272,218.982572 123.467232,220.995738 C123.249136,221.218228 122.904637,221.065467 122.433736,220.537455 C121.962834,220.009443 121.38228,219.124961 120.692073,217.884009 C121.853181,214.819836 122.433736,211.975835 122.433736,209.352006 C122.433736,206.728178 121.772653,203.944176 120.450487,201 L120.450487,201 Z M57,201 C55.4424036,203.89219 54.6636055,206.650199 54.6636055,209.274028 C54.6636055,211.897857 55.2417295,214.754239 56.3979776,217.843174 L53.983255,220.995738 C53.0808153,220.551391 52.4834592,220.153735 52.1911868,219.80277 C51.1988734,218.611187 50.8188293,217.129236 50.4800795,216.400976 C48.496589,212.136775 48.4163802,208.361938 48.4573689,206.195645 C48.5134971,203.229215 48.820515,201.497334 49.3784226,201 L57,201 Z",
    id: "Hands"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/Hands.1ef372720ee74b0594c1be216a13f8e4.svg";
export { ForwardRef as ReactComponent };